export default {

    validateLenght(string, min, max) {
        if (min === null) {
            return (string.length <= max)
        }
        else {
            return (string.length >= min && string.length <= max)
        }
    },

    validateLenghtWithClearing(string, max, elem, val) {
        if (string.length > max) {
            document.getElementById(elem).value = val
        }
        return (string.length <= max)
    },

    validateIntOrDouble(string) {
        string = string.toString();
        if (string.indexOf(',') > -1) {
            string = string.replace(',', '.');
        }
        return parseFloat(string.match(/^-?\d*(\.\d+)?$/)) >= 0;
    },

    validateInt(string, minus) {
        if (Boolean(minus)) {
            return /^-?\d+$/.test(string);
        }
        else {
            return /^\d+$/.test(string)
        }
    },

    validateSzerokoscDlugoscWysokoscGeo(val, typ) {
        val = val.toString()
        if (val.indexOf(',') > -1) {
            val = val.replace(',', '.');
        }
        val = parseFloat(val);

        if (typ === 'sz') {
            return (val > 0 && val <= 90)
        } else if (typ === 'dl') {
            return (val > 0 && val <= 180)
        }
        else {
            // typ === npm
            return (val < 2500)
        }
    },

    addClearing(elem, val) {
        document.getElementById(elem).value = val
    },


    // uzywane w inpucie hasło, do sprawdzenia poprawności wprowadzonego nowego lub zmienianego hasła

    czyZawieraDuzaLitere(string) {
        if (string.length == 0) return false
        let pattern = "QWERTYUIOPASDFGHJKLZXCVBNM";
        let zawiera = false;
        for (let i = 0; i < pattern.length; i++) {
            if (string.indexOf(pattern[i]) > -1) {
                zawiera = true;
            }
        }
        return zawiera
    },

    czyZawieraCyfreLubZnakSpecjalny(string) {
        if (string.length == 0) return false
        let pattern = "1234567890!@#$%^&*()-_=+[]{};:/?<>,.";
        let zawiera = false;
        for (let i = 0; i < pattern.length; i++) {
            if (string.indexOf(pattern[i]) > -1) {
                zawiera = true;
            }
        }
        return zawiera
    },


    validateNIP(nip) {
            //Check length
        if (nip == null)
            return false;
        nip = nip.replace(/\-/g, '');
        if (nip.length != 10)
            return false;

            //Check digits
        for (let i = 0; i < 10; i++)
            if (isNaN(nip[i]))
                return false;

            //Check checkdigit
        let sum = 6 * nip[0] +
            5 * nip[1] +
            7 * nip[2] +
            2 * nip[3] +
            3 * nip[4] +
            4 * nip[5] +
            5 * nip[6] +
            6 * nip[7] +
            7 * nip[8];
        sum %= 11;
        if (nip[9] != sum)
            return false;

        return true;
    }

}


// WEBPACK FOOTER //
// ./src/utilities/Validator.js